import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { Layout } from '@/data/types/Layout';
import { Stack } from '@mui/material';
import { FC } from 'react';
import { cartStacklayoutMainSX } from '@/components/layouts/styles/cartStack';
import { useCart } from '@/data/Content/Cart';
import { Footer } from '@/components/content/Footer';

export const CartStack: FC<{ layout: Layout }> = ({ layout }) => {
	const cantidad = useCart().count;

	return (
		<>
			<LayoutSlot slot={layout.slots.header} />
			<Stack component="main" alignItems="center" sx={cartStacklayoutMainSX(cantidad)}>
				<LayoutSlot slot={layout.slots.first} />
				<LayoutSlot slot={layout.slots.second} />
				{cantidad > 0 ? <LayoutSlot slot={layout.slots.footer} /> : <Footer id="footer-id" />}
			</Stack>
		</>
	);
};
